import * as React from 'react';
import * as sub from "./style.module.scss";
export const Subs = ({ data }) => {
  return (
    <section className={sub.sub}>
      <div className="container">
        <div className="row">
          <div className={`col-12 col-lg-12 ${sub.col}`}>
            <div className="row">
              {
                data.map((elem, index) => (
                  <div className={`col col-md-6 ${sub.content}`} key={index}>
                    <h2>Сезон {elem.season}</h2>
                    <br/>
                    {
                      elem.subsLinks.map((subLink, index) => (
                        <a
                          key={index}
                          href={`https://fs.advance.ru/landing-pages/inostrannye_yazyki/subtitry_k_serialam_na_angliyskom_yazyke/subs/${subLink}`}>
                          Серия&nbsp;{index+1}
                        </a>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
